export default {
  buttons: {
    more_payment_methods: 'Mai multe metode de plată',
  },
  toasts: {
    processing: 'Se procesează detaliile de plată. Vă vom notifica când procesarea este finalizată.',
    failed: 'Procesarea detaliilor de plată a eșuat. Vă rugăm să încercați o altă metodă de plată.',
    failed_to_load: 'Formularul de plată nu a putut fi încărcat. Reîncarcă pagina și încearcă din nou.',
    failed_to_save_payment_method: 'Salvarea metodei de plată a eșuat',
    failed_to_create_checkout_session: 'Ceva a mers greșit, vă rugăm să încercați din nou',
  },
};
